export default "__VITE_ASSET__7cnNR5Ml__"